import { render, staticRenderFns } from "./JumboDoughnutApexChart.vue?vue&type=template&id=5aeb58f5&scoped=true&"
import script from "./JumboDoughnutApexChart.vue?vue&type=script&lang=js&"
export * from "./JumboDoughnutApexChart.vue?vue&type=script&lang=js&"
import style0 from "./JumboDoughnutApexChart.vue?vue&type=style&index=0&id=5aeb58f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb58f5",
  null
  
)

export default component.exports